export const GET_ALL_USER_MESSAGE_HISTORY = "GET_ALL_USER_MESSAGE_HISTORY"
export const GET_ALL_USER_MESSAGE = "GET_ALL_USER_MESSAGE"
export const HIDE_USER_MESSAGE = "HIDE_USER_MESSAGE"
export const LOOK_USER_MESSAGE = "LOOK_USER_MESSAGE"
export const CREATE_USER_MESSAGE_HISTORY = "CREATE_USER_MESSAGE_HISTORY"
export const UPDATE_USER_MESSAGE_HISTORY = "UPDATE_USER_MESSAGE_HISTORY"
export const DELETE_USER_MESSAGE_HISTORY = "DELETE_USER_MESSAGE_HISTORY"
